export type Listener<T> = (state: T, prev: T) => void;

export interface Store<T extends object> {
  get(): T;
  set(next: T): void;
  patch(p: Partial<T>): void;
  subscribe(l: Listener<T>): () => void;
}

export function createStore<T extends object>(initial: T): Store<T> {
  let state = initial;
  const listeners = new Set<Listener<T>>();
  const set = (next: T) => {
    const prev = state;
    state = next;
    for (const l of listeners) l(state, prev);
  };
  return {
    get: () => state,
    set,
    patch: (p) => set({ ...state, ...p }),
    subscribe: (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
  };
}
